import axios from "axios";
import { api } from "./api_route";

export const checkUniqueness = async (data) => {
  try {
    const response = await axios.post(
      `${api}/organizationBranch/checkUniqueness`,
      data
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        success: false,
        message: "Network error occurred",
      }
    );
  }
};

// Create new branch
export const createBranch = async (branchData) => {
  try {
    const response = await axios.post(
      `${api}/organizationBranch/create`,
      branchData
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        success: false,
        message: "Failed to create branch",
      }
    );
  }
};

// Update branch
export const updateBranch = async (values) => {
  try {
    const { id } = values;
    const response = await axios.put(
      `${api}/organizationBranch/update/${id}`,
      values
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        success: false,
        message: "Failed to update branch",
      }
    );
  }
};

// Toggle branch status (soft delete)
export const organizationBranchStatus = async (id) => {
  try {
    const response = await axios.patch(
      `${api}/organizationBranch/${id}/status`
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        success: false,
        message: "Failed to toggle branch status",
      }
    );
  }
};

// Delete branch (hard delete)
export const deleteBranch = async (id, updatedBy) => {
  try {
    const response = await axios.delete(`${api}/organizationBranch/${id}`, {
      data: { updatedBy },
    });
    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        success: false,
        message: "Failed to delete branch",
      }
    );
  }
};

// Get all branches
export const getAllBranches = async () => {
  try {
    const response = await axios.get(`${api}/organizationBranch/`);

    return response.data;
  } catch (error) {
    throw (
      error.response?.data || {
        success: false,
        message: "Failed to fetch branches",
      }
    );
  }
};
